// extracted by mini-css-extract-plugin
export default {"container":"ResourceConfig_container__8WqKI","label":"ResourceConfig_label__1YDbj","value":"ResourceConfig_value__11Uij"};